if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      const checkedBumps = Array.from(document.querySelectorAll('order-bump')).filter((b) => {
        const toggle = b.querySelector('[data-order-bump-toggle]');
        return toggle && toggle.checked && b.dataset.variantId;
      });
      if (checkedBumps.length > 0) {
        const mainId = formData.get('id');
        const mainQty = formData.get('quantity') || '1';
        formData.delete('id');
        formData.delete('quantity');
        const bundleId = 'b-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
        formData.append('items[0][id]', mainId);
        formData.append('items[0][quantity]', mainQty);
        formData.append('items[0][properties][_bundle_id]', bundleId);
        formData.append('items[0][properties][_bundle_role]', 'main');
        checkedBumps.forEach((b, i) => {
          const idx = i + 1;
          formData.append(`items[${idx}][id]`, b.dataset.variantId);
          formData.append(`items[${idx}][quantity]`, '1');
          formData.append(`items[${idx}][properties][_bundle_id]`, bundleId);
          formData.append(`items[${idx}][properties][_bundle_role]`, 'bump');
        });
      }

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

class stickyCartModal extends HTMLElement {
  constructor() {
    super();
    // 1024px = le breakpoint auquel component-sticky-addtocart.css bascule la
    // barre en mise en page mobile (chip format + CTA pleine largeur). C'etait
    // 749px ici, donc en tablette la barre gardait la mise en page mobile sans
    // les regles de masquage qui vont avec.
    this.mobileMql = window.matchMedia('(max-width: 1024px)');
    this.mainBtnVisible = false;
    this.pickerVisible = false;
    window.addEventListener('scroll', this.update.bind(this));
    window.addEventListener('resize', this.update.bind(this));

    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button && button.querySelector('[name="add"]');
    if (addButton && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries) => {
        this.mainBtnVisible = entries[0].isIntersecting;
        this.update();
      }, { threshold: 0 });
      this.observer.observe(addButton);
    }

    // La barre s'efface aussi quand le selecteur de format est a l'ecran :
    // inutile de proposer un raccourci vers un choix deja sous les yeux.
    // rootMargin negatif en bas : le picker ne compte comme visible qu'une fois
    // remonte de 80px, donc degage de la zone occupee par la barre elle-meme.
    // Les pickers du mauvais breakpoint sont en display:none, ils n'intersectent
    // jamais : les observer tous est sans risque.
    // Meme raison pour le bouton des CARTES produit : dans les recommandations,
    // il porte lui aussi "Choisir un format". Deux boutons au libelle identique
    // a l'ecran, dont un agit sur un AUTRE produit, et on ne sait plus lequel
    // fait quoi. Celui qu'on a sous les yeux doit gagner, la barre s'efface.
    // .jdgm-write-rev-link : le bouton « Ecrire un avis » de judge.me. Meme
    // raison, c'est une action pleine largeur qui appelle le pouce au meme
    // endroit que la barre. Il est injecte par le script de judge.me bien apres
    // le chargement, d'ou l'interet du MutationObserver plus bas.
    const CONCURRENTS = 'format-picker, .product-card__quickadd-inline-submit, .jdgm-write-rev-link';
    if ('IntersectionObserver' in window) {
      this.visiblePickers = new Set();
      this.pickerObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.visiblePickers.add(entry.target);
          else this.visiblePickers.delete(entry.target);
        });
        // une carte peut disparaitre du DOM (filtre, re-rendu de section) sans
        // que l'observateur ne repasse : on purge ce qui n'est plus attache
        this.visiblePickers.forEach((el) => { if (!el.isConnected) this.visiblePickers.delete(el); });
        this.pickerVisible = this.visiblePickers.size > 0;
        this.update();
      }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });

      const observerDans = (racine) => {
        if (racine.nodeType !== 1 && racine !== document) return;
        if (racine.matches && racine.matches(CONCURRENTS)) this.pickerObserver.observe(racine);
        racine.querySelectorAll(CONCURRENTS).forEach((el) => this.pickerObserver.observe(el));
      };
      observerDans(document);

      // Les recommandations sont injectees APRES le chargement de la page :
      // sans cette surveillance, leurs boutons ne seraient jamais observes et
      // la barre resterait affichee par-dessus.
      this.cartesObserver = new MutationObserver((mutations) => {
        mutations.forEach((m) => { m.addedNodes.forEach(observerDans); });
      });
      this.cartesObserver.observe(document.body, { childList: true, subtree: true });
    }

    this.update();
    document.querySelector('footer').classList.add('sticky-cart-modal_bottom_padding');
  }
  update(){
    const button = document.getElementById(`product-form-${this.dataset.section}`);
	const addButton = button.querySelector('[name="add"]');
    const rangeToShowModal = this.getTop(addButton) + button.clientHeight;
    // La barre n'apparait qu'une fois le bouton d'ajout principal depasse. Elle
    // etait auparavant affichee d'emblee sur mobile, ou elle recouvrait le titre
    // du produit des le chargement de la page.
    let shouldShow = window.scrollY >= rangeToShowModal;
    // Deux exceptions sur mobile, ou la barre est affichee des l'arrivee :
    // - coffrets (sans variante), comportement historique conserve
    // - tant que le format n'a pas ete choisi : la barre ne porte alors que
    //   "Selectionner le format", une invitation qui n'a d'interet qu'avant
    //   d'atteindre le selecteur. Elle s'efface ensuite devant lui.
    if (this.mobileMql.matches
        && (this.classList.contains('sticky-cart-modal--no-variants')
            || this.classList.contains('sticky-cart-modal--unchosen'))) {
      shouldShow = true;
    }
    if (this.mainBtnVisible || (this.mobileMql.matches && this.pickerVisible)) {
      shouldShow = false;
    }
    // Prioritaire sur tout le reste : la bottom sheet est un enfant de ce
    // composant, donc masquer la barre (visibility + transform) la masquerait
    // avec elle en pleine utilisation.
    if (this.querySelector('.sticky-sheet.is-open')) {
      shouldShow = true;
    }
    if(shouldShow && !this.classList.contains('show-modal')){
      this.classList.add('show-modal');
      document.querySelector('body').classList.add('modal__sticky-cart');
    }
    if(!shouldShow && this.classList.contains('show-modal')){
      this.classList.remove('show-modal');
      document.querySelector('body').classList.remove('modal__sticky-cart');
    }
  }
  getTop(el) {
    return el.offsetTop + (el.offsetParent && this.getTop(el.offsetParent));
  }
}
customElements.define('sticky-cart-modal', stickyCartModal);

(function () {
  function toggleDynamicCheckout() {
    const anyBumpChecked = document.querySelectorAll('order-bump [data-order-bump-toggle]:checked').length > 0;
    document.querySelectorAll('.shopify-payment-button').forEach((el) => {
      el.style.display = anyBumpChecked ? 'none' : '';
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches('[data-order-bump-toggle]')) {
      toggleDynamicCheckout();
    }
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', toggleDynamicCheckout);
  } else {
    toggleDynamicCheckout();
  }
})();

